import React, { useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { Route } from "react-router";
import RootContainer from "./RootContainer";
import "../assets/scss/themes.scss";
import { Provider } from "react-redux";
import { configureStore } from "../store/configureStore";
import { PersistGate } from "redux-persist/integration/react";
import { ProviderContainer } from "./ProviderContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppContainer() {
  const store = useMemo(() => configureStore(), []);

  if (!store) {
    return null;
  }

  return (
    <Provider store={store.store}>
      <PersistGate persistor={store.persistor}>
        <ProviderContainer>
          <BrowserRouter>
            <>
              <Route component={RootContainer} />
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss={true}
                draggable={true}
                theme="colored"
                pauseOnHover={true}
              />
            </>
          </BrowserRouter>
        </ProviderContainer>
      </PersistGate>
    </Provider>
  );
}

export default AppContainer;
